import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomTitleStrategy extends TitleStrategy {
    constructor(private readonly title: Title, private translateService: TranslateService) {
        super();
    }

    override updateTitle() {
        this.translateService.get('page-title').subscribe((res: string) => {
            this.title.setTitle(res);
        });
    }
}
